export const Alumnos = {
	LISTAR: 'alumnos',
	LISTAR_PAGINADO: 'alumnos/paginado',
	OBTENER_POR_NUMERO_CONTROL: (numeroControl) =>
		`alumnos/numeroControl/${numeroControl}`,
	ACTUALIZAR_PRIORITARIO: (numeroControl) =>
		`alumnos/actualizarPrioritario/${numeroControl}`,
	OBTENER_MENSAJES: (numeroControl) => `alumnos/mensajes/${numeroControl}`,
	OBTENER_HISTORICOS: (numeroControl) => `alumnos/historicos/${numeroControl}`,
	ENVIAR_CORREO: (numeroControl) => `alumnos/enviarCorreo/${numeroControl}`,
	VERIFICAR_CORREO: (numeroControl) =>
		`alumnos/verificarCodigoCorreo/${numeroControl}`,
	ACTUALIZAR_INFORMACION: (numeroControl) =>
		`alumnos/actualizarInformacionAlumno/${numeroControl}`,
	ACTUALIZAR_STEP_ACTIVE: (numeroControl) =>
		`alumnos/actualizarStepActive/${numeroControl}`,
	ENVIAR_MENSAJE: (numeroControl) => `alumnos/enviarMensaje/${numeroControl}`,
	ACTIVAR: (numeroControl) => `alumnos/activar/${numeroControl}`,
	INACTIVAR: (numeroControl) => `alumnos/inactivar/${numeroControl}`,
	GUARDAR_EXPEDIENTE_FISICO: (numeroControl) =>
		`alumnos/expedienteFisico/${numeroControl}`,
	RESTABLECER_OPCION_TITULACION: (numeroControl) =>
		`alumnos/restablecerOpcionTitulacion/${numeroControl}`,
	CAMBIAR_TIENE_FOTOGRAFIAS: (numeroControl) =>
		`alumnos/cambiarTieneFotografias/${numeroControl}`
};

export const OpcionesTitulacion = {
	LISTAR: 'opcionesTitulacion'
};

export const Planes = {
	LISTAR: 'planes'
};

export const Carreras = {
	LISTAR: 'carreras'
};

export const AlumnosTramiteDocumentos = {
	OBTENER_POR_NUMERO_CONTROL: (numeroControl) =>
		`alumnosTramiteDocumentos/numeroControl/${numeroControl}`,
	SUBIR_DOCUMENTO: (numeroControl) =>
		`alumnosTramiteDocumentos/subirDocumento/${numeroControl}`,
	APROBAR_DOCUMENTO: (numeroControl) =>
		`alumnosTramiteDocumentos/aprobarDocumento/${numeroControl}`,
	RECHAZAR_DOCUMENTO: (numeroControl) =>
		`alumnosTramiteDocumentos/rechazarDocumento/${numeroControl}`,
	RECHAZAR_DOCUMENTO_CON_SOLICITUD: (numeroControl) =>
		`alumnosTramiteDocumentos/rechazarDocumentoConSolicitud/${numeroControl}`,
	DOCUMENTO_APROBADOS: (numeroControl, paso) =>
		`alumnosTramiteDocumentos/documentoAprobados/${numeroControl}/${paso}`,
	GENERAR_DOCUMENTO_NO_INCONVENIENTES: (numeroControl) =>
		`alumnosTramiteDocumentos/generarDocumentoNoInconvenientes/${numeroControl}`,
	ENVIAR_DOCUMENTO_NO_INCONVENIENTES: (numeroControl) =>
		`alumnosTramiteDocumentos/enviarDocumentoNoInconvenientes/${numeroControl}`,
	OBTENER_ZIP: (numeroControl) =>
		`alumnosTramiteDocumentos/obtenerZip/${numeroControl}`
};

export const Usuarios = {
	ACTUALIZAR_CONTRASENIA: (userName) =>
		`usuarios/contrasenia/usuario/${userName}`
};
